<template>
  <div>
    <v-card flat color="background rounded-xl">
      <v-card-text>
        <table>
          <tbody>
            <tr>
              <th class="text-right py-1 pr-3">
                Név
              </th>
              <td class="text--text font-weight-bold">
                {{ deviceData.name }}
              </td>
            </tr>
            <tr>
              <th class="text-right py-1 pr-3">
                Szériaszám
              </th>
              <td class="text--text font-weight-bold">
                {{ deviceData.serialNumber }}
              </td>
            </tr>
            <tr>
              <th class="text-right py-1 pr-3">
                Kapcsolat
              </th>
              <td class="text--text font-weight-bold">
                {{ deviceData.ip }}:{{ deviceData.port }}
              </td>
            </tr>
            <tr>
              <th class="text-right py-1 pr-3">
                Belső óra
              </th>
              <td class="text--text font-weight-bold d-flex align-center">
                {{ deviceData.time | moment('lll') }}:{{ deviceData.time | moment('ss') }}

                <v-btn
                  color="primary"
                  text
                  fab
                  small
                  class="ml-auto rounded-xl"
                  @click="syncTime"
                  title="Kontroller idő szinkronizálása">
                  <v-icon>mdi-sync</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <th class="text-right py-1 pr-3">
                HTTP API
              </th>
              <td class="text--text font-weight-bold">
                <v-icon v-if="deviceData.hasHttpApi" color="success">mdi-check-bold</v-icon>
                <v-icon v-else color="error">mdi-close-thick</v-icon>
              </td>
            </tr>
          </tbody>
        </table>

        <v-divider class="my-6" />

        <div class="d-flex align-center">
          <v-text-field
            label="RFID alapú jogosultság ellenőrzés"
            dense
            v-model="rfid"
            filled
            hide-details />
          <v-btn
            color="primary"
            class="ml-3 rounded-xl"
            depressed
            fab
            small
            @click="fetchCardInfo">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </div>

        <div v-if="cardData.cardNo">
          <table class="my-6">
            <tbody>
              <tr>
                <td class="py-1 pr-3 text-right">Kártyaszám (DEC)</td>
                <td class="font-weight-bold">{{ cardData.cardNo }}</td>
              </tr>
              <tr>
                <td class="py-1 pr-3 text-right">Érvényesség</td>
                <td class="font-weight-bold">
                  <v-chip
                    v-if="cardData.cardValid"
                    :color="cardData.cardValid ? 'success' : 'error'"
                    small
                    dark>{{
                      cardData.cardValid ? 'Érvényes' : 'Nem érvényes' }}</v-chip>
                </td>
              </tr>
              <tr>
                <td class="py-1 pr-3 text-right">Relé jogosultságok</td>
                <td class="font-weight-bold">
                  <v-chip
                    v-for="(right, index) in cardData.doorRights"
                    :color="right ? 'success' : 'error'"
                    small
                    dark
                    class="mr-2"
                    :key="`door-right-${index}`">
                    #{{ index + 1 }}: {{ right ? 'Jogosult' : 'Nem jogosult' }}
                  </v-chip>
                </td>
              </tr>
            </tbody>
          </table>

          <v-card
            v-for="(plan, index) in cardData.cardRightPlans"
            flat
            class="mt-3 rounded-xl"
            :key="`card-right-plan-${index}`">
            <v-card-title>Relé #{{ index + 1 }} kártyajogok</v-card-title>
            <v-card-text>
              <template v-for="right in plan">
                <v-card
                  v-if="right"
                  flat
                  color="background"
                  class="mb-2 rounded-xl"
                  :key="`card-right-plan-${index}-right-${right.index}`">
                  <v-card-title>
                    Sablon #{{ right.index }}
                    <v-chip
                      :color="right.enabled ? 'success' : 'error'"
                      small
                      dark
                      class="ml-3">
                      {{ right.enabled ? 'Érvényes' : 'Nem érvényes' }}
                    </v-chip>
                  </v-card-title>

                  <v-card-text>
                    <table>
                      <template v-for="(segment, jndex) in right.segments">
                        <tr v-for="interval in segment" :key="`card-right-plan-${index}-right-${right.index}-segment-${jndex}-interval-${interval.begin}-${interval.end}`">
                          <td class="pr-3 text-right">{{ resolveDayName(jndex) }}</td>
                          <td>{{ formatTime(interval.begin) }} - {{ formatTime(interval.end) }}</td>
                        </tr>
                      </template>
                    </table>
                  </v-card-text>
                </v-card>
              </template>

              <div v-if="plan.every(e => !e)">Nincs jogosultság erre a relére</div>
            </v-card-text>
          </v-card>

        </div>

        <v-divider class="my-6" />

        <v-row>
          <template v-for="(weekplan, index) in deviceData.weekPlans">
            <v-col
              cols="12"
              md="6"
              lg="4"
              xl="2"
              v-if="weekplan.enabled"
              class="my-3"
              :key="`weekplan-${weekplan.index}`">
              <v-card flat color="backgound" class="rounded-xl">
                <v-card-title>Sablon #{{ weekplan.index }}</v-card-title>
                <v-card-text>
                  <div v-if="index == 0">Alapértelmezett jogosultság: Mindig engedélyezve</div>
                  <div v-else-if="index == 1">Alapértelmezett jogosultság: Mindig tiltva</div>
                  <table v-else>
                    <template v-for="(segment, index) in weekplan.segments">
                      <tr v-if="segment[0]" :key="`weekplan-${weekplan.index}-day-${weekplan.segments.indexOf(segment)}`">
                        <td class="pr-3 text-right">{{ resolveDayName(index) }}</td>
                        <td class="font-weight-bold">{{ formatTime2(segment[0].begin) }} - {{ formatTime2(segment[0].end) }}</td>
                      </tr>
                    </template>
                  </table>
                </v-card-text>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
let interval = null;

export default {
  props: {
    controller: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      deviceData: {},
      cardData: {},
      rfid: process.env.NODE_ENV === 'development' ? '7E3966CE' : '',
    };
  },

  watch: {
    controller: {
      handler() {
        this.fetchDeviceInfo();
      },
      immediate: true,
    },
  },

  mounted() {
    interval = setInterval(() => {
      this.fetchTime();
    }, 1000);
  },

  beforeDestroy() {
    clearInterval(interval);
  },

  methods: {
    async fetchDeviceInfo() {
      this.loading = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_HUNIOM_API_URL}controller/${this.controller.serial_number}/device/meta`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        this.deviceData = (await response.json()).controller;
        console.log('Debug info fetched:', response);
      } catch (error) {
        console.error('Error fetching debug info:', error);
        return null;
      } finally {
        this.loading = false;
      }
    },

    async fetchCardInfo() {
      this.cardData = {};
      const response = await fetch(`${process.env.VUE_APP_HUNIOM_API_URL}controller/${this.controller.serial_number}/device/card/${this.rfid}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      this.cardData = (await response.json()).card;
    },

    async syncTime() {
      const response = await fetch(`${process.env.VUE_APP_HUNIOM_API_URL}controller/${this.controller.serial_number}/device/sync-time`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      this.deviceData.time = (await response.json()).controller.time;
    },

    async fetchTime() {
      const response = await fetch(`${process.env.VUE_APP_HUNIOM_API_URL}controller/${this.controller.serial_number}/device/time`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      this.deviceData.time = (await response.json()).controller.time;
    },

    formatTime(time) {
      return time.hour.toString().padStart(2, '0') + ':' + time.minute.toString().padStart(2, '0');
    },

    formatTime2(timeString) {
      const [hour, minute] = timeString.split(':');
      return hour.toString().padStart(2, '0') + ':' + minute.toString().padStart(2, '0');
    },

    resolveDayName(dayIndex) {
      switch (dayIndex) {
        case 0:
          return 'Hé';
        case 1:
          return 'Ke';
        case 2:
          return 'Sz';
        case 3:
          return 'Cs';
        case 4:
          return 'Pé';
        case 5:
          return 'Sz';
        case 6:
          return 'Va';
        default:
          return dayIndex;
      }
    },
  },
};
</script>
